// extracted by mini-css-extract-plugin
export default {"link":"LinkResolverLink__link___xX3u9","referenceStyle":"LinkResolverLink__referenceStyle___zaVaE"};